// eslint-disable-next-line unicorn/filename-case
import {UAParserService} from 'Services/UAParserService';
import loadCSS from 'Utils/loadCSS';

require('domready')(() => {
    if(UAParserService.getBrowser().name === 'IE') {
        loadCSS('/etc/designs/white-label/clientlib_base/css/hack-ie11.css');
    }
});
